import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  Badge,
  Button,
  Col,
  Input,
  Menu,
  message,
  Row,
  Space,
  Spin,
  Table,
  Tabs,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  product_getMarketplaces,
  product_getStatusCount,
  product_getProducts,
} from "services/dataservice";
import { Link } from "react-router-dom";
import { EditOutlined, DeleteOutlined, UndoOutlined } from "@ant-design/icons";
import { product_deactivate } from "services/dataservice";
import { product_getQueueCount } from "services/dataservice";
import { product_activate } from "services/dataservice";
import { product_categories_sync } from "services/dataservice";
export default function ProductTestList() {
  const queryClient = useQueryClient();
  const [marketplaces, setMarketplaces] = useState([]);
  const [products, setProducts] = useState([]);
  const [marketplace, setMarketplace] = useState(null);
  const [status, setStatus] = useState("draft");
  const [statusObj, setStatusObj] = useState({
    draft: 0,
    live: 0,

    //deactivate: 0,
  });
  const [queue, setQueue] = useState("processing");
  const [queueObj, setQueueObj] = useState({
    processing: 0,
    success: 0,
    failed: 0,
  });
  const [temp, setTemp] = useState([]);
  const { isFetching: isMarketplacesFetching } = useQuery({
    queryKey: ["product-marketplaces"],
    queryFn: () => product_getMarketplaces(),
    onSuccess: (data) => {
      const d = [{ userMarketplaceId: 0, name: "All", marketplaceId: 0 }, ...data.data.data];
      setMarketplaces(d);
      if (data.data.data.length > 0) {
        setMarketplace(d[0].userMarketplaceId);
      }
    },
    onError: () => {},
  });
  const { isFetching: isStatusFetching } = useQuery({
    queryKey: ["product-list", "status", { marketplace }],
    queryFn: () => product_getStatusCount({ userMarketplaceId: marketplace }),
    enabled: Boolean(marketplace),
    onSuccess: (data) => {
      setStatusObj(data.data.data);
    },
    onError: () => {},
  });
  const { isFetching: isQueueFetching } = useQuery({
    queryKey: ["product-list", "queue", { marketplace, status }],
    queryFn: () => product_getQueueCount({ userMarketplaceId: marketplace, status }),
    enabled: Boolean(marketplace),
    onSuccess: (data) => {
      setQueueObj(data.data.data);
    },
    onError: () => {},
  });
  const { isFetching: isProductsFetching } = useQuery({
    queryKey: ["product-list", { marketplace, status, queue }],
    queryFn: () => product_getProducts({ userMarketplaceId: marketplace, status, queue }),
    enabled: marketplace !== null,
    onSuccess: (data) => {
      setProducts(data.data.data);
      setTemp(data.data.data);
    },
    onError: () => {},
  });
  const deactivateMutation = useMutation(product_deactivate, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["product-list"]);
      message.success(data.data.message);
    },
    onError: (data) => {
      message.error(data.response.data.message);
    },
  });
  const activateMutation = useMutation(product_activate, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["product-list"]);
      message.success(data.data.message);
    },
    onError: (data) => {
      message.error(data.response.data.message);
    },
  });
  const deactivateStatus = deactivateMutation.status === "loading";
  const activateStatus = activateMutation.status === "loading";

  const {  refetch } = useQuery({
    queryKey: ["product-sync-category"],
    queryFn: () => product_categories_sync(),
    enabled: false,
    onSuccess: () => {
      message.success("Categories sync in progress");
    },
    onError: () => {},
  });

  console.log(products);

  return (
    <div className="content">
      <Spin
        tip="Loading"
        spinning={
          isMarketplacesFetching ||
          isStatusFetching ||
          isQueueFetching ||
          isProductsFetching ||
          deactivateStatus ||
          activateStatus
        }
      >
        <div style={{ display: "flex" }}>
          <div>
            {/* <Tabs
              onChange={(v) => {
                setMarketplace(v);
              }}
              tabPosition="left"
              items={marketplaces.map((x, index) => {
                return {
                  label: x.name,
                  key: x.userMarketplaceId,
                };
              })}
            /> */}
            <Menu
              onClick={(v) => setMarketplace(parseInt(v.key))}
              defaultSelectedKeys={["0"]}
              items={marketplaces.map((x) => ({ label: x.name, key: x.userMarketplaceId }))}
            />
          </div>

          <div style={{ width: "100%", marginLeft: "1rem" }}>
            <Row style={{ marginBottom: "1rem" }}>
              <Col span={16}>
                <Input.Search
                  style={{ width: "300px" }}
                  type="text"
                  placeholder="Search by name"
                  onSearch={(v) => {
                    if (!Boolean(v.trim())) {
                      setProducts(temp);
                      return;
                    }
                    const filter = products.filter((x) =>
                      x.name.toLowerCase().includes(v.toLowerCase().trim())
                    );
                    setProducts(filter);
                  }}
                  allowClear
                />
              </Col>
              <Col span={8} style={{ textAlign: "end" }}>
                <Link to="/admin/product/add">
                  <Button>Add Product</Button>
                </Link>
                <Button
                  style={{ marginLeft: "1rem" }}
                  type="primary"
                  onClick={() => {
                    refetch();
                  }}
                >
                  Sync Magento Categories
                </Button>
              </Col>
            </Row>
            {/* <div style={{ marginBottom: "1rem", textAlign: "end" }}>
              <Link to="/admin/product/add">
                <Button>Add Product</Button>
              </Link>
            </div> */}
            {marketplace !== 0 && (
              <>
                <Tabs
                  onChange={(v) => {
                    setStatus(v);
                  }}
                  type="card"
                  items={[
                    {
                      label: (
                        <span>
                          Draft{" "}
                          <Badge
                            count={statusObj.draft}
                            overflowCount={statusObj.draft + 1}
                            showZero
                          />
                        </span>
                      ),
                      key: "draft",
                    },
                    {
                      label: (
                        <span>
                          {" "}
                          Live{" "}
                          <Badge
                            count={statusObj.live}
                            overflowCount={statusObj.live + 1}
                            showZero
                          />
                        </span>
                      ),
                      key: "live",
                    },
                  ]}
                />
                <div style={{ marginBottom: "1rem" }}>
                  <Button
                    type={queue === "processing" ? "primary" : "default"}
                    onClick={() => {
                      setQueue("processing");
                    }}
                  >
                    Processing{" "}
                    <Badge
                      style={{ marginLeft: "2px" }}
                      count={queueObj.processing}
                      overflowCount={queueObj.processing + 1}
                      showZero
                    />
                  </Button>
                  <Button
                    type={queue === "success" ? "primary" : "default"}
                    onClick={() => {
                      setQueue("success");
                    }}
                  >
                    Success
                    <Badge
                      style={{ marginLeft: "2px" }}
                      count={queueObj.success}
                      overflowCount={queueObj.success + 1}
                      showZero
                    />
                  </Button>
                  <Button
                    type={queue === "failed" ? "primary" : "default"}
                    onClick={() => {
                      setQueue("failed");
                    }}
                  >
                    Failed
                    <Badge
                      style={{ marginLeft: "2px" }}
                      count={queueObj.failed}
                      overflowCount={queueObj.failed + 1}
                      showZero
                    />
                  </Button>
                </div>
              </>
            )}

            {marketplace === 0 ? (
              <Table
                columns={[
                  {
                    title: "Name",
                    dataIndex: "name",
                    key: "name",
                    sorter: (a, b) => a.name.localeCompare(b.name),
                  },
                  {
                    title: "Marketplaces",
                    dataIndex: "marketplaces",
                    key: "marketplaces",
                    render: (_, e) =>
                      e?.marketplaces?.split(",").map((x) => <p style={{ margin: 0 }}>{x}</p>),
                  },
                  {
                    title: "Action",
                    key: "action",
                    render: (_, e) => {
                      return (
                        <Space size="middle">
                          <Link to={{ pathname: "/admin/product/edit", state: { id: e.id } }}>
                            <Tooltip title="Edit">
                              <EditOutlined style={{ color: "#51c41a" }} />
                            </Tooltip>
                          </Link>
                          <Tooltip title="Deactivate">
                            <DeleteOutlined
                              style={{ color: "#f24d4f" }}
                              onClick={() => {
                                deactivateMutation.mutate(
                                  { productId: e.id, userMarketplaceId: marketplace },
                                  {}
                                );
                              }}
                            />
                          </Tooltip>
                        </Space>
                      );
                    },
                  },
                ]}
                dataSource={products.map((x, index) => {
                  return {
                    ...x,
                    key: x.id + index.toString(),
                  };
                })}
              />
            ) : (
              <Table
                columns={[
                  {
                    title: "Name",
                    dataIndex: "name",
                    key: "name",
                    sorter: (a, b) => a.name.localeCompare(b.name),
                  },
                  {
                    title: "MarketplaceS SKU",
                    dataIndex: "marketplaceSKU",
                    key: "marketplaceSKU",
                    render: (_, e) =>
                      e?.marketplaceSKU?.split(",").map((x) => <p style={{ margin: 0 }}>{x}</p>),
                  },
                  {
                    title: "Status",
                    dataIndex: "status",
                    key: "status",
                  },
                  {
                    title: "Action",
                    key: "action",
                    render: (_, e) => {
                      return (
                        <Space size="middle">
                          {status !== "deactivate" && queue !== "processing" && (
                            <Link to={{ pathname: "/admin/product/edit", state: { id: e.id } }}>
                              <Tooltip title="Edit">
                                <EditOutlined style={{ color: "#51c41a" }} />
                              </Tooltip>
                            </Link>
                          )}

                          {status === "live" && queue === "success" && (
                            <Tooltip title="Deactivate">
                              <DeleteOutlined
                                style={{ color: "#f24d4f" }}
                                onClick={() => {
                                  deactivateMutation.mutate(
                                    { productId: e.id, userMarketplaceId: marketplace },
                                    {}
                                  );
                                }}
                              />
                            </Tooltip>
                          )}
                          {status === "draft" && queue === "success" && (
                            <Tooltip title="Activate">
                              <UndoOutlined
                                style={{ color: "#f24d4f" }}
                                onClick={() => {
                                  activateMutation.mutate(
                                    { productId: e.id, userMarketplaceId: marketplace },
                                    {}
                                  );
                                }}
                              />
                            </Tooltip>
                          )}
                        </Space>
                      );
                    },
                  },
                ]}
                dataSource={products.map((x, index) => {
                  return {
                    ...x,
                    key: x.marketplaceSKU + index.toString(),
                  };
                })}
              />
            )}
          </div>
        </div>
      </Spin>
    </div>
  );
}
